import { ProductUpdateForm } from "./ProductUpdate.schema";

export const defaultProductUpdateValues = {
  title: "",
  content: "",
  severity: 0,
} as ProductUpdateForm;
